export type LogLevel = "off" | "normal" | "verbose" | "detector" | "everything";

declare global {
  interface Window {
    cardScanDebugLog: string[];
  }
}

export class GlobalLogger {
  static startingLogLevel: LogLevel = "off";
  static LogLevel: LogLevel = GlobalLogger.startingLogLevel;

  static setLogLevel(level: LogLevel) {
    GlobalLogger.LogLevel = level;
  }

  static shouldLog(level: LogLevel): boolean {
    if (GlobalLogger.LogLevel === "off") {
      return false;
    }
    if (GlobalLogger.LogLevel === "everything") {
      return true;
    }
    if (GlobalLogger.LogLevel === "detector") {
      return level === "detector";
    }
    if (GlobalLogger.LogLevel === "verbose") {
      return level !== "detector" && level !== "everything";
    }
    return level === "normal";
  }

  static getLog(): string[] {
    return window.cardScanDebugLog || [];
  }

  // This is a special log function that is used before the logger is fully initialized
  static earlyLog(message: string) {
    const timestamp = new Date().toISOString();
    if (!window.cardScanDebugLog) {
      window.cardScanDebugLog = [];
    }
    window.cardScanDebugLog.push(`${timestamp} [CardScan] INFO: ${message}`);
    console.log(`${timestamp} [CardScan] INFO: ${message}`);
  }

  static log(message: string, level: LogLevel = "normal") {
    if (GlobalLogger.shouldLog(level)) {
      const timestamp = new Date().toISOString();
      if (!window.cardScanDebugLog) {
        window.cardScanDebugLog = [];
      }
      window.cardScanDebugLog.push(`${timestamp} [CardScan] INFO: ${message}`);
      console.log(`${timestamp} [CardScan] INFO: ${message}`);
    }
  }

  static debug(message: string, level: LogLevel = "verbose") {
    if (GlobalLogger.shouldLog(level)) {
      const timestamp = new Date().toISOString();
      if (!window.cardScanDebugLog) {
        window.cardScanDebugLog = [];
      }
      window.cardScanDebugLog.push(`${timestamp} [CardScan] DEBUG: ${message}`);
      console.debug(`${timestamp} [CardScan] DEBUG: ${message}`);
    }
  }

  static error(message: string) {
    const timestamp = new Date().toISOString();
    if (!window.cardScanDebugLog) {
      window.cardScanDebugLog = [];
    }
    window.cardScanDebugLog.push(`${timestamp} [CardScan] ERROR: ${message}`);
    console.error(`${timestamp} [CardScan] ERROR: ${message}`);
  }
}
